export const LAUNCH_LEGACY_LOCATION_CREATE = 'Create New'
export const LAUNCH_LEGACY_LOCATION_EDIT = 'Edit Button'
export const LAUNCH_LEGACY_LOCATION_FORMNAME = 'Form Name'

